import withTranslation from 'framework/components/hoc/withTranslation';
import { Header } from './Header';

export default withTranslation(Header);
